import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface Program {
  _id: string;
  name: string;
  description?: string;
  status?: "active" | "inactive" | string;
  parentDepartmentId?: string;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
}

export type ProgramResponse = {
  success: boolean;
  message: string;
  data: Program;
};

const fetchProgramById = async (id: string): Promise<ProgramResponse> =>
  (await customAxios.get<ProgramResponse>(`/programs/program/${id}`)).data;

export const useGetProgramId = (id?: string) =>
  useQuery<ProgramResponse, AxiosError>(
    ["programs", id],
    () => fetchProgramById(id as string),
    {
      enabled: !!id,
      onError: (error) =>
        showNotification({
          title: "Error Loading Program",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load program",
          color: "red",
        }),
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    }
  );
